import { openGallery } from '../add-edit-item/appUtils/AppUtils';
import { getImagePath } from '../../common/fileUtills';
import { updateProductMediaService, getImagePath as getImagePathProductImage } from '../../common/productImageUtils';
import { useSelector } from 'react-redux';

export const uploadPhotoFromApp = ({showToastMessage, showHideLoader, setVendorImages, toggleGalleryModal, supplierId, vendorImages}, onUploadCB) => {
    let url = '/vendorapis/products/image/uploadProductImageForLibrary?supplierId='+supplierId;
    let session = useSelector(state => state.session);
    openGallery({
        index: 0, 
        imgUploadUrl: url, 
        callback: (res)=>{
            if(res.data){
                let _data = JSON.parse(res.data)[0];
                if (_data.status === "success") {
                    showHideLoader({
                        showLoader: false
                    })
                    const imageObj = {
                        actualPath: getImagePath(_data.imgURL),
                        imageUrl: _data.imgURL,
                        uploaded: true,
                        galleryId: _data.id
                    }
                    setVendorImages([imageObj,...vendorImages]);
                    if(onUploadCB){
                        onUploadCB();
                    }else{
                        showToastMessage({
                            showToastMessage: true,
                            message: 'Photo Added Successfully',
                            duration: 5000,
                            bottom: session.hasGlassFooter ? '80px' : '0px',
                        })
                    }
                    setTimeout(() => {
                        toggleGalleryModal({
                            selectedImages:  [0],
                            addModal: {
                                show: true
                            }
                        })
                    }, 250)
                } else {
                    showHideLoader({
                        showLoader: false
                    })
                    console.log("Error while uploading: ", res.data);
                }
            }else if(res.error=="invalidFile"){
                showHideLoader({
                    showLoader: false
                })
                showToastMessage({
                    showToastMessage: true,
                    message: 'Only JPG, JPEG & PNG Files are Supported',
                    duration: 5000,
                    bottom: session.hasGlassFooter ? '80px' : '0px',
                });
            }else {
                //Waiting to Upload
                showHideLoader({
                    showLoader: true
                })
                console.log("waiting to upload");
            }
        }
    })
}

export const addJdGalleryPhotosToProduct = ({
    cb,
    token,
    source,
    productId,
    curImageUrl = "",
    vendorImages = [],
    selectedImages = [],
    fromListing = false,
    isAddEditProduct,
    isAddEditProductOmni
}) => {
    const imageArr = vendorImages.filter((cur, index)=>selectedImages.includes(index));
    let finalImageUrl = imageArr.filter((cur) => {
		return cur.uploaded
	})
	finalImageUrl = finalImageUrl.map(obj => obj.imageUrl);
	let combinedUrl = '';
	if(curImageUrl){
		combinedUrl = curImageUrl + "," + finalImageUrl.join(",");
	}else{
		combinedUrl = finalImageUrl.join(",");
	}
    if(combinedUrl.split(",").length > 40) {
        return cb('maxImageToast');
    }
    if(isAddEditProduct || isAddEditProductOmni){
        const imageUrlArr = combinedUrl.split(",").map((cur) => {
            return {
                imgURL: cur,
                actualPath: getImagePathProductImage(cur),
                uploaded: true
            }
        })
        return cb('successToast', imageUrlArr);
    }
    updateProductMediaService({
        productId,
        imageUrl: combinedUrl,
        token,
        source,
        fromListing
    }).then(() => {
        const imageUrlArr = combinedUrl.split(",").map((cur) => {
            return {
                imgURL: cur,
                actualPath: getImagePath(cur),
                uploaded: true
            }
        })
        return cb('successToast', imageUrlArr);
    })
}
